import { render, staticRenderFns } from "./ExemptionSettingDialog.vue?vue&type=template&id=23a10529&scoped=true"
import script from "./ExemptionSettingDialog.vue?vue&type=script&lang=js"
export * from "./ExemptionSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./ExemptionSettingDialog.vue?vue&type=style&index=0&id=23a10529&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a10529",
  null
  
)

export default component.exports